angular
    .module('tradersyard')
    .factory('account-select-factory', [
        'graph-analytic-factory',
        function ($client) {
            var request = {},
                options = {
                    visible: true,
                };

            return {
                query: function (id, call) {
                    if (request[id] === undefined) {
                        request[id] = $client.accounts(id, { params: options });
                    }
                    call(request[id]);
                },
            };
        },
    ])
    .directive('accountSelect', [
        '$parse',
        'graph-analytic-factory',
        'account-select-factory',
        '$rootScope',
        '$flex.array',
        '$timeout',
        '$location',
        function ($parse, $client, $factory, $root, $array, $timeout, $location) {
            return {
                scope: true,
                link: function ($scope, $element, $attr) {
                    $scope.c_account = 0;
                    $scope.isAccountPreselected = false;
                    $scope.accounts = [];

                    var entry, entryId;

                    $timeout(function () {
                        entry = $parse($attr.entry)($scope);

                        entryId = $parse($attr.entryId)($scope);

                        $scope.query();
                    });

                    $scope.select = function (account_id) {
                        $scope.c_account = account_id;

                        $root.$broadcast('analytic-account-select', account_id);
                    };

                    $scope.$on('analytic-account-select', function (e, account) {
                        $scope.c_account = account;
                    });

                    $scope.query = function () {
                        $factory.query(entryId, function (request) {
                            request.then(function (response) {
                                const preselectedAccount = parseInt($location.search().account);
                                $scope.isAccountPreselected = Boolean(preselectedAccount);

                                if (response.data.state === 0 && response.data.data.length > 0) {
                                    $scope.accounts = $scope.accounts.concat(response.data.data);

                                    for (var i = 0; i < $scope.accounts.length; ++i) {
                                        if ($scope.accounts[i].main === true) {
                                            $scope.c_account = $scope.accounts[i].id;
                                        }
                                    }

                                }
                            });
                        });
                    };
                },
            };
        },
    ])
    .directive('clearAnalyticsHistory', [
        '$rootScope',
        '$parse',
        function ($rootScope, $parse) {
            return {
                scope: true,
                link: function ($scope, $element, $attr) {
                    $element.bind('click', function () {
                        $rootScope.$broadcast('touchClearAnalyticsHistory', $parse($attr.accountId)($scope));
                    });
                },
            };
        },
    ])
    .directive('clearAnalyticsHistoryForm', [
        '$rootScope',
        '$parse',
        'graph-analytic-factory',
        function ($rootScope, $parse, $analyticFactory) {
            return {
                scope: true,
                link: function ($scope, $element, $attr) {
                    var bodyElement = angular.element(document.querySelector('body'));
                    $scope.isOpened = false;
                    // 'upload-from' : 'now', 'begin'
                    $scope.form = { uploadFrom: 'now' };

                    var digest = function () {
                        if (!$scope.$$phase) {
                            $scope.$digest();
                        }
                    };

                    $scope.$on('analytic-account-select', function (event, accountId) {
                        $scope.altAccountId = accountId;
                        digest();
                    });

                    $scope.$on('touchClearAnalyticsHistory', function (event, accountId) {
                        $scope.accountId = accountId;
                        $scope.isOpened = true;
                        bodyElement.addClass('no-scroll');
                        digest();
                    });

                    $scope.hide = function () {
                        $scope.accountId = undefined;
                        $scope.isOpened = false;
                        bodyElement.removeClass('no-scroll');
                        digest();
                    };

                    $scope.submit = function () {
                        $analyticFactory
                            .clearByAccount('me', $scope.accountId || $scope.altAccountId, {
                                params: { 'upload-from': $scope.form.uploadFrom },
                            })
                            .then(function (response) {
                                if (response.data.state === 0) {
                                    $rootScope.$broadcast(
                                        'analytic-account-select',
                                        $scope.accountId || $scope.altAccountId
                                    );
                                    $scope.hide();
                                }
                            });
                    };
                },
            };
        },
    ]);
